import { Box, FormControlLabel, Switch, Typography } from '@cmg/design-system';
import type { ChangeEvent } from 'react';

export type ConfigurationSwitchProps = {
  description: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function ConfigurationSwitch(props: Readonly<ConfigurationSwitchProps>) {
  const { description, label, checked, disabled, onChange } = props;

  return (
    <Box p={1}>
      <FormControlLabel
        label={
          <Typography variant="body2">
            {label}
            <br />
            <Typography component="span" variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Typography>
        }
        control={<Switch onChange={onChange} />}
        checked={checked}
        disabled={disabled}
      />
    </Box>
  );
}
